import {
  Box,
  Flex,
  Spinner,
  Text,
  Center,
  Button,
  useToast,
  Textarea,
} from '@chakra-ui/react';
import { MdArrowForward } from 'react-icons/md';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { MakerCheckerTasks, MakerCheckerStatus } from 'config/constant';
import Card from 'components/card/Card';
import MakerCheckerApi from 'api/makerchecker';
import CheckerDetailsTable from './components/checkerDetailsTable';
import TaskCashDeposit from './components/taskInfoCards/taskCashDeposit';
import SavingPlanMoneyWithdrawal from './components/taskInfoCards/withdrawalmoneysavingplan';
import SavingPlanSellGold from './components/taskInfoCards/savingplansellgold';
import TaskSavingPlanCloseStore from './components/taskInfoCards/savingplanclosestore';
import TaskSellGoldStore from './components/taskInfoCards/sellGoldStore';
import SellGold from './components/taskInfoCards/sellGold';
import Bullion from './components/taskInfoCards/bullion';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';

const MakerChecker = () => {
  const [makerCheckerData, setMakerCheckerData] = useState({});
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [refresh, setRefresh] = useState(false);
  const [comments, setComments] = useState('');
  const [userId, setUserId] = useState(null);
  const { getPermissionsForModule } = usePermissions();
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const permissions = getPermissionsForModule([Modules.MakerCheckers]);
    setPermissions(permissions);
  }, []);

  useEffect(() => {
    const fetchUserId = () => {
      try {
        const storedUser = sessionStorage.getItem('user');
        const parsedUser = storedUser ? JSON.parse(storedUser) : null;
        setUserId(parsedUser?.id || null); // Set userId or null if not found
      } catch (error) {
        console.error('Error parsing user from sessionStorage:', error);
        setUserId(null); // Set to null on error
      }
    };

    fetchUserId();
  }, []);

  const taskTypeCard = [
    {
      value: 'CASH_DEPOSIT',
      component: <TaskCashDeposit details={makerCheckerData?.details} />,
    },
    {
      value: 'SAVING_PLAN_CLOSE_STORE',
      component: <TaskSavingPlanCloseStore details={makerCheckerData?.details} />,
    },
    {
      value: 'GOLD_SELL_STORE',
      component: <TaskSellGoldStore details={makerCheckerData?.details} />,
    },
    {
      value: 'GOLD_SELL',
      component: <SellGold details={makerCheckerData?.details} />,
    },
    {
      value: 'BULLION',
      component: <Bullion details={makerCheckerData?.details} />,
    },
    {
      value: 'WITHDRAWAL_MONEY_SAVING_PLAN',
      component: <SavingPlanMoneyWithdrawal details={makerCheckerData?.details} />,
    },
    {
      value: 'SELL_GOLD_SAVING_PLAN',
      component: <SavingPlanSellGold details={makerCheckerData?.details} />,
    },
  ];

  const makerCheckerId = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    const parts = url.split('/');
    const id = parts[parts.length - 1];
    return id;
  }

  const GoToCustomerUser = (id) => {
    // console.log(id)
    const url = `/admin/customeruser/${id}`;
    window.open(url, '_blank');
  };

  const GoToAdminUser = (id) => {
    // console.log(id)
    const url = `/admin/adminuser/${id}`;
    window.open(url, '_blank');
  };

  const MakerCheckerStatusUpdate = async (approve) => {
    if (!comments || comments.trim() === '') {
      toast({
        title: 'Comment is Mandatory',
        description: `Please provide a comment before ${approve === 'ACCEPT' ? 'Approving' : 'Rejecting'}.`,
        status: 'warning',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      return;
    }
    console.log('Approve value', approve);
    try {
      setLoading(true);
      let response = await MakerCheckerApi.Status({
        approve,
        makerCheckerId,
        comments,
      });
      response = response.data;
      console.log('response from MakerChecker', response);
      setLoading(false);
      if (response.status_code === 200) {
        toast({
          title: response?.message || 'Successfully Updated',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        FetchMakerChecker();
        setRefresh(!refresh);
      } else {
        toast({
          title: response?.message || 'Error Updating',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      toast({
        title: 'Unable to Update',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      console.log(err);
    }
  };

  const FetchMakerChecker = async () => {
    try {
      setLoading(true);
      let response = await MakerCheckerApi.getById(makerCheckerId);
      response = response.data;
      console.log('response from MakerChecker', response);
      setLoading(false);
      if (response.status_code === 200) {
        setMakerCheckerData(response?.data);
      } else {
        setMakerCheckerData({});
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchMakerChecker();
  }, []);

  if (!permissions?.read) {
    return <NoPermissionsMessage module={Modules.MakerCheckers} />;
  }
  const handleButtonClick = () => {
    const userId = makerCheckerData?.maker_id;
    console.log('user id', userId, makerCheckerData);
    if (makerCheckerData?.user_type === 'CUSTOMER') {
      GoToCustomerUser(userId);
    } else {
      GoToAdminUser(userId);
    }
  };

  return loading ? (
    <Center
      mt='10rem'
      width='100%'
    // bgColor='red'
    >
      <Spinner size='xl' />
    </Center>
  ) : (
    <Box mt='8rem'>
      <Flex direction='column' gap={8}>
        <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
          <Card display='flex' gap={8}>
            <Flex direction='column' gap={2}>
              <Text fontWeight='medium'>Created by</Text>
              <Button variant='light' onClick={handleButtonClick}>
                <Text fontWeight='bold' mr={2}>
                  {makerCheckerData?.name}
                </Text>
                <MdArrowForward />
              </Button>
            </Flex>
            <Flex direction='column' gap={2}>
              <Text fontWeight='medium'>Task</Text>
              <Text ml={2}>
                {
                  MakerCheckerTasks.find(
                    (option) => option.value === makerCheckerData?.task
                  )?.label
                }
              </Text>
            </Flex>
          </Card>
          <Card display='flex' gap={8}>
            <Flex direction='column' gap={2}>
              <Text fontWeight='medium'>Date of Creation</Text>
              <Text ml={2}>
                {moment(makerCheckerData.created_at).format('DD MMM YY, HH:mm')}
              </Text>
            </Flex>
            <Flex direction='column' gap={2}>
              <Text fontWeight='medium'>Status</Text>
              <Text
                me='10px'
                fontSize='sm'
                fontWeight='700'
                color={
                  makerCheckerData?.status === 'COMPLETED'
                    ? 'green'
                    : makerCheckerData?.status === 'FAILED'
                      ? 'red'
                      : ''
                }
              >
                {MakerCheckerStatus.find(
                  (option) => option.value === makerCheckerData?.status
                )?.label.toUpperCase()}
                {
                  (makerCheckerData.required_checks > 1 && makerCheckerData.status === 'PENDING') ? ' (' + makerCheckerData.required_checks + ')' : ''
                }
              </Text>
            </Flex>
          </Card>
        </Flex>

        <Flex
          width='100%'
        // bgColor='yellow'
        >
          {
            taskTypeCard.find((task) => task.value === makerCheckerData?.task)
              ?.component
          }
        </Flex>

        {makerCheckerData?.checker?.length > 0 && (
          <Flex mt={2} direction='column' gap={3}>
            <Text fontSize='2xl' fontWeight='500'>
              Checker Details
            </Text>
            <CheckerDetailsTable checkerDetails={makerCheckerData?.checker} />
          </Flex>
        )}
        {makerCheckerData.status === 'PENDING' &&
          userId &&
          userId !== makerCheckerData?.maker_id &&
          permissions?.read &&
          permissions?.create &&
          !makerCheckerData?.checker?.some(c => c.checker_id == userId) && (
            <>
              <Flex direction='column' gap={2} width='100%' maxW='xl'>
                <Flex gap={1}>
                  <Text fontWeight='medium'>Comment</Text>
                  <Text fontWeight='medium' color='red.500'>
                    *
                  </Text>
                  <Text fontWeight='medium' fontSize='xs' alignSelf='center' color='gray.500'>
                    (Mandatory)
                  </Text>
                </Flex>
                <Textarea
                  variant='auth'
                  maxlength='400'
                  placeholder='Enter your comments here...'
                  onChange={(e) => setComments(e.target.value)}
                />
              </Flex>
              <Flex gap={4} width='100%' maxW='xl'>
                <Button
                  colorScheme='green'
                  onClick={() => {
                    MakerCheckerStatusUpdate('ACCEPT');
                  }}
                  minW='150px'
                  width='100%'
                >
                  Approve
                </Button>
                <Button
                  colorScheme='red'
                  onClick={() => {
                    MakerCheckerStatusUpdate('REJECT');
                  }}
                  minW='150px'
                  width='100%'
                >
                  Reject
                </Button>
              </Flex>
            </>
          )}
      </Flex>
    </Box>
  );
};

export default MakerChecker;
